export default function Timeline({ items }: { items: any[] }) {
  return (
    <div className="timeline">
      {items.length ? (
        items.map((item, i) => (
          <div key={i} className="timeline-item">
            <div className="dot" />
            <div className="timeline-content">
              <div className="timeline-title">{item.title}</div>
              <div className="timeline-date">{item.date}</div>
            </div>
          </div>
        ))
      ) : (
        <div className="empty">История пуста</div>
      )}
    </div>
  );
}